import React from 'react'

const ViewStaffList = ({userList}) => {
  return (
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="exampleModalEdit"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
        
       
      <div className=" w-full">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          View Staff
        </h1>
        <img className='m-auto w-40' src={`${userList?.profile?.image}`} alt="" />
        <div className="">
          <div className="relative">
            <div className="w-ful border-b-2 border-primary-blue grid grid-cols-1 text-lg sm:text-sm md:grid-cols-3 md:text-lg">
              <div className="text-primary-red border-primary-blue flex w-full items-center gap-3 border-x-2 border-t-2 p-2 font-medium md:border-l-2 md:border-r-0">
                <p className="flex-shrink-0">Staff Name :</p>
                <input
                  type="text"
                // value={userList?.profile?.f_name?? "null"}
                value={`${userList?.profile?.f_name} ${userList?.profile?.l_name}`}
                  
                  name=""
                //   value={userList.profile.f_name}
                  className="text-primary-blue w-full outline-none"
                  placeholder="Staff Name"
                //   {...register("f_name", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-0 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Address</p>
                <input
                  type="text"
                  name=""
                  value={`${userList?.profile?.address}`}
                  className="text-primary-blue w-full outline-none"
                  placeholder="Address"
                //   {...register("address", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-2 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Job Join Date:</p>
                <input
                  type="text"
                  value={`${userList?.created_at}`}

                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="date"
                //   {...register("job_join_date", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-0 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Father Name:</p>
                <input
                  type="text"
                  value={`${userList?.profile?.father_name}`}

                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Father Name"
                //   {...register("father_name", { required: false })}
                  id=""
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 p-2 font-medium md:border-l-2 md:border-r-0">
                <p className="flex-shrink-0">Post :</p>
                <input
                  type="text"
                  value={`${userList?.profile?.position}`}
                  
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Post"
                  id=""
                //   {...register("position", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 border-r-2 p-2 font-medium md:border-l-2">
                <p className="flex-shrink-0">Contact No :</p>
                <input
                  type="text"
                  value={`${userList?.phone}`}

                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="phone number"
                //   {...register("phone", { required: false })}
                  id=""
                />
              </div>
            </div>
           
          </div>
          {/* btns */}
          {/* <div className="flex justify-end">
          <a
            href=""
            className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          >
            Save
          </a>
        </div> */}
        </div>
        {/* staff socila media */}
        <div className="">
          <h1 className="text-primary-red text-center font-bold underline">
            Social Media Link
          </h1>
          <div className="relative mt-3">
            <div className="w-ful grid grid-cols-1 text-lg sm:text-sm md:grid-cols-3 md:text-lg xl:grid-cols-4">
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-t-2 p-2 font-medium md:border-y-2 md:border-l-2">
                <p className="flex-shrink-0">Email :</p>
                <input
                  type="text"
                  name=""
                  value={userList.email}
                  className="text-primary-blue w-full outline-none"
                  placeholder="Email"
                //   {...register("email", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-y-2 p-2 font-medium md:border-l-0">
                <p className="flex-shrink-0">Messenger :</p>
                <input
                  type="text"
                  value={`${userList?.profile?.messenger}`}
                  
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Facebook"
                //   {...register("messenger", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-b-2 p-2 font-medium md:border-y-2 md:border-l-0 md:border-r-2">
                <p className="flex-shrink-0">Viber :</p>
                <input
                  type="text"
                  value={`${userList?.profile?.viber}`}

                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Viber"
                //   {...register("viber", { required: false })}
                />
              </div>
              <div className="text-primary-red border-primary-blue flex w-full items-center border-x-2 border-b-2 p-2 font-medium md:border-y-2 md:border-l-0 md:border-r-2">
                <p className="flex-shrink-0">Whatsapp :</p>
                <input
                  value={`${userList?.profile?.whatsapp}`}

                  type="text"
                  name=""
                  className="text-primary-blue w-full outline-none"
                  placeholder="Whatsapp"
                //   {...register("whatsapp", { required: false })}
                />
              </div>
            </div>
          </div>
          {/* btns */}
          {/* <div className="flex justify-end">
          <a
            href=""
            className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
          >
            Save
          </a>
        </div> */}
        </div>
        
      </div>
   
   
          
        </div>
        
      </div>
    </div>
  </div>
  )
}

export default ViewStaffList